<li class="nav-item dropdown nav-user-menu" dropdown>
  <a href="javascript:;" class="nav-link" dropdownToggle>
    <hr />
    <img
      class="user-image img-circle elevation-2"
      [src]="getProfileImage()"
      alt="User Image"
      [ngClass]="{ 'circle-image': isCircleImage() }"
      [ngStyle]="{
        margin: sidebarExpanded ? 'auto' : ''
      }"
    />
  </a>

  <div
    [ngClass]="{
      'menu-expanded': sidebarExpanded,
      'menu-collapsed': !sidebarExpanded,
      'elevation-3': !sidebarExpanded
    }"
    class="dropdown-menu"
    *dropdownMenu
  >
    <a
      *ngIf="['candidato', 'administrativo'].includes(route)"
      class="dropdown-item text"
      href="javascript:;"
      [routerLink]="['perfil']"
    >
      <i class="far fa-user text"></i> Meu Perfil
    </a>

    <a class="dropdown-item text" [routerLink]="termosLink()">
      <i class="far fa-file-alt text"></i> Termos de Uso
    </a>
    <a class="dropdown-item text" [routerLink]="politicasLink()">
      <i class="fas fa-shield-alt text"></i> Política de Privacidade
    </a>
    <hr />
    <a class="dropdown-item exit" href="javascript:;" (click)="logout()">
      <i class="fas fa-sign-out-alt exit"></i> {{ "Logout" | localize }}
    </a>
  </div>
</li>
